import { Order_By, useGetPostsByCategoryIdQuery } from '@/generated/graphql';
import { WrapperPostForUser } from './WrapperPostForUser';
import { useMemo } from 'react';
import format from '@/utils/format';
import { IPostCardProps } from '@/interfaces/card';
import { BigThumbnailPostCard } from '../Shared/PostCard';
import { Divider } from '../Shared';
import { Button } from 'antd';

const ReadMoreSection = ({ categoryId, idPost }: WrapperPostForUser) => {
  const { data, fetchMore } = useGetPostsByCategoryIdQuery({
    variables: {
      limit: 3,
      offset: 9,
      args: {
        category_id: categoryId,
      },
      orderBy: {
        published_at: Order_By.Desc,
      },
      where: {
        published_at: {
          _is_null: false,
          _lte: 'now()',
        },
        id: {
          _neq: idPost,
        },
      },
    },
  });

  const filteredPosts: Array<IPostCardProps> = useMemo(() => {
    return format.formatDataPost(data?.get_posts_by_category_id);
  }, [data]);

  const isHaveMoreItem = useMemo(
    () =>
      Number(filteredPosts?.length) <
      Number(data?.postAggregate?.aggregate?.count) - 9,
    [data?.postAggregate?.aggregate?.count, filteredPosts?.length],
  );

  return (
    <div>
      {filteredPosts?.length !== 0 ? (
        <>
          <h3 className="uppercase text-[#3F4D5C] text-[18px] font-black text-center">
            Đọc thêm
          </h3>
          <div className="mt-4 mb-5">
            {filteredPosts?.map((item: IPostCardProps, index: any) => {
              return (
                <>
                  <BigThumbnailPostCard key={index} {...item} horizontal />
                  {index !== filteredPosts.length - 1 && <Divider />}
                </>
              );
            })}
          </div>
        </>
      ) : (
        <></>
      )}

      {isHaveMoreItem && (
        <Button
          className="w-full !bg-Silver rounded-lg self-center text-[16px] h-fit !font-bold text-DarkBlue"
          onClick={() =>
            fetchMore({
              variables: {
                offset: Number(data?.get_posts_by_category_id?.length) + 9,
              },
              updateQuery: (prev, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prev;
                return {
                  ...prev,
                  get_posts_by_category_id: [
                    ...prev.get_posts_by_category_id,
                    ...fetchMoreResult.get_posts_by_category_id,
                  ],
                };
              },
            })
          }
        >
          Xem thêm
        </Button>
      )}
    </div>
  );
};

export default ReadMoreSection;
